import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IChatMessage {
  id: string;
  text: string;
  sender: "user" | "bot";
  timestamp: Date;
  suggestions?: string[];
  actions?: Array<{
    type: string;
    label: string;
    value: any;
  }>;
  navigateSuggestion?: { tab: "help" | "faqs"; pdfPage?: number };
}

interface ChatState {
  messages: IChatMessage[];
  conversationId?: string;
  isOpen: boolean;
  isLoading: boolean;
}

const initialState: ChatState = {
  messages: [],
  conversationId: undefined,
  isOpen: false,
  isLoading: false,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    addMessage(state, action: PayloadAction<IChatMessage>) {
      state.messages.push(action.payload);
    },
    setConversationId(state, action: PayloadAction<string>) {
      state.conversationId = action.payload;
    },
    setChatOpen(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
    setChatLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    clearChat(state) {
      state.messages = [];
      state.conversationId = undefined;
    },
    addBotResponse(
      state,
      action: PayloadAction<{
        text: string;
        suggestions?: string[];
        actions?: Array<{
          type: string;
          label: string;
          value: any;
        }>;
        navigateSuggestion?: { tab: "help" | "faqs"; pdfPage?: number };
      }>
    ) {
      const message: IChatMessage = {
        id: `bot_${Date.now()}`,
        text: action.payload.text,
        sender: "bot",
        timestamp: new Date(),
        suggestions: action.payload.suggestions,
        actions: action.payload.actions,
        navigateSuggestion: action.payload.navigateSuggestion,
      };
      state.messages.push(message);
    },
  },
});

export const {
  addMessage,
  setConversationId,
  setChatOpen,
  setChatLoading,
  clearChat,
  addBotResponse,
} = chatSlice.actions;
export const chatReducer = chatSlice.reducer;
